import {
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'action-button',
  templateUrl: './action_button.component.html',
  styleUrls: ['./action_button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ActionButtonComponent implements OnInit {
  @Input() image?: string;
  @Input() text: string;
  @Input() buttonStyle: string;
  @Input() disabled: boolean = false;
  constructor() {}

  ngOnInit(): void {}
}
